import type { ColumnsType } from 'antd/es/table';
import type { MyVotesData } from '../types';

import { TFunction } from 'i18next';

import withLoadingSkeleton from '@/HOCs/withLoadingSkeleton';

export const myVotesColumns = (
  isLoading: boolean,
  t: TFunction<'investorRelations', 'meetings'>,
): ColumnsType<MyVotesData | Record<string, number>> => [
  {
    title: t('clause'),
    render: withLoadingSkeleton(isLoading, (val: MyVotesData) => val.clause),
    sorter: true,
  },
  {
    title: t('pointDescription'),
    render: withLoadingSkeleton(isLoading, (val: MyVotesData) => val.points_description),
    sorter: true,
  },
  {
    title: t('myVote'),
    render: withLoadingSkeleton(isLoading, (val: MyVotesData) => val.vote || '-'),
    sorter: true,
  },
];
